import { defineModule } from '@kubdee/sdk'
import { MODULES } from '@kubdee/shared'
import { migrations } from './migrations'
import { aiDoctypes } from './doctypes'

// To change icon, also add the new icon to apps/web/src/lib/icon-registry.ts
const MODULE_ICON = 'Bot'
const MODULE_COLOR = '#2490EF'

export default defineModule({
  name: MODULES.AI,
  label: 'AI Agents',
  icon: MODULE_ICON,
  color: MODULE_COLOR,
  version: '1.0.0',
  dependencies: [MODULES.CORE],
  requiredPlatformCapabilities: ['workers_ai'],
  category: 'core',
  isSystemModule: false,

  schemas: {},
  routes: {},
  navigation: {
    label: 'AI',
    icon: MODULE_ICON,
    groups: [
      {
        label: 'AI Agents',
        items: [
          { label: 'Agents', path: '/ai/agents', icon: 'Bot' },
          { label: 'ฐานความรู้', path: '/ai/knowledge', icon: 'BookOpen' },
        ],
      },
      {
        label: 'ตั้งค่า',
        items: [
          { label: 'LLM Providers', path: '/ai/settings/llm-providers', icon: 'Cpu' },
        ],
      },
    ],
  },
  permissions: {},
  hooks: {},

  doctypes: [
    { key: "agents", label: "AI Agents" },
    { key: "tools", label: "เครื่องมือ" },
  ],
  availableHooks: [],

  extendSchemas: {},
  fixtures: [],

  moduleMigrations: migrations,

  // Doctype Catalog First (#644) — metadata-only registry rows consumed by
  // the tenant-worker boot loop. AI service/routes still own all writes.
  registeredDoctypes: aiDoctypes,
})
